import { PersonalInfoFormActionType } from "app/hooks/";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import { useInfoFormErrorsContext } from "pages/checkout/providers/InfoFormErrorsProvider";
import { useEffect } from "react";
import { api } from "shared/api";
import FormGroup from "shared/ui/FormGroup";
import Input from "shared/ui/input";
import Label from "shared/ui/label";
import Heading from "shared/ui/typography/Heading";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutInfoBillingProps {
  className?: string;
}

const CheckoutInfoBilling = ({ className }: CheckoutInfoBillingProps) => {
  const { state, dispatch } = useCheckoutInfoContext();
  const { formErrors } = useInfoFormErrorsContext();

  const {
    invoiceCity,
    invoiceHouseNumber,
    invoiceStreet,
    invoiceZipCode,
    invoiceProvince,
    invoiceMunicipality,
    invoiceReference,
  } = state;

  const updateInvoicePostcode = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_INVOICE_ZIP_CODE,
      payload: e.target.value,
    });
  };
  const updateInvoiceHouseNo = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_INVOICE_HOUSE_NUMBER,
      payload: e.target.value,
    });
  };
  const updateInvoiceReference = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_INVOICE_REFERENCE,
      payload: e.target.value,
    });
  };

  // TODO: extract to hook
  const verifyZipCode = async () => {
    try {
      const res = await api().gersValidateZipCode(
        invoiceZipCode,
        invoiceHouseNumber
      );
      // setIsAddressVerified(true);
      dispatch({
        type: PersonalInfoFormActionType.UPDATE_INVOICE_STREET,
        payload: res.data.street,
      });
      dispatch({
        type: PersonalInfoFormActionType.UPDATE_INVOICE_CITY,
        payload: res.data.city,
      });
      dispatch({
        type: PersonalInfoFormActionType.UPDATE_INVOICE_MUNICIPALITY,
        payload: res.data.municipality,
      });
      dispatch({
        type: PersonalInfoFormActionType.UPDATE_INVOICE_PROVINCE,
        payload: res.data.province,
      });
    } catch (err: any) {
      // setIsAddressVerified(false);
      if (invoiceStreet) {
        dispatch({
          type: PersonalInfoFormActionType.UPDATE_INVOICE_STREET,
          payload: "",
        });
      }

      if (invoiceCity) {
        dispatch({
          type: PersonalInfoFormActionType.UPDATE_INVOICE_CITY,
          payload: "",
        });
      }
      if (invoiceMunicipality) {
        dispatch({
          type: PersonalInfoFormActionType.UPDATE_INVOICE_MUNICIPALITY,
          payload: "",
        });
      }
      if (invoiceProvince) {
        dispatch({
          type: PersonalInfoFormActionType.UPDATE_INVOICE_PROVINCE,
          payload: "",
        });
      }
    }
  };

  useEffect(() => {
    if (!invoiceZipCode) return;
    if (!invoiceHouseNumber) return;

    verifyZipCode().catch(console.error);
  }, [invoiceZipCode, invoiceHouseNumber]);

  return (
    <div
      className={concatClassnames(
        "gg-grid gg-grid-cols-12 gg-gap-5 gg-mb-7",
        className
      )}
    >
      <Heading headingLevel="h2" className="gg-text-2xl gg-mb-2 gg-col-span-12">
        Factuuradres
      </Heading>

      <FormGroup className="gg-col-span-12">
        <Label htmlFor="invoiceReference" className="gg-mb-1">
          Referentie
        </Label>
        <Input
          onChange={updateInvoiceReference}
          id="invoiceReference"
          placeholder="Referentie"
          value={invoiceReference}
        />
      </FormGroup>

      <FormGroup
        className="sm:gg-col-span-6"
        errorMessage={formErrors["invoiceZipCode"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="invoiceZipCode" className="gg-mb-1" required>
          Postcode
        </Label>
        <Input
          id="invoiceZipCode"
          placeholder="Postcode"
          value={invoiceZipCode}
          onChange={updateInvoicePostcode}
          error={!!formErrors["invoiceZipCode"]}
          required
        />
      </FormGroup>

      <FormGroup
        className="sm:gg-col-span-6"
        errorMessage={formErrors["invoiceHouseNumber"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="invoiceHouseNumber" className="gg-mb-1" required>
          Huisnummer
        </Label>
        <Input
          onChange={updateInvoiceHouseNo}
          id="invoiceHouseNumber"
          value={invoiceHouseNumber}
          placeholder="Huisnummer"
          error={!!formErrors["invoiceHouseNumber"]}
          required
        />
      </FormGroup>

      <FormGroup className="sm:gg-col-span-6">
        <Label htmlFor="invoice-adres" className="gg-mb-1" required>
          Adres
        </Label>
        <Input
          onChange={() => {}}
          value={invoiceStreet}
          id="invoice-adres"
          placeholder="Adres"
          required
          readOnly
        />
      </FormGroup>

      <FormGroup className="sm:gg-col-span-6">
        <Label htmlFor="invoice-woonplaats" className="gg-mb-1" required>
          Woonplaats
        </Label>
        <Input
          onChange={() => {}}
          id="invoice-woonplaats"
          placeholder="Woonplaats"
          required
          value={invoiceCity}
          readOnly
        />
      </FormGroup>
    </div>
  );
};
export default CheckoutInfoBilling;
